import { useState } from "react";
import useFormatNumbers from "../../../customHooks/useFormatNumbers";
import { useIsomorphicLayoutEffect } from "../../../customHooks/useIsomorphicLayoutEffect";
type Props = {
  received?: number;
  left?: number;
  progressPrecentage?: number;
  blocks?: any;
};
const HomeDonateProgressBar = ({
  received = 0,
  left,
  progressPrecentage,
  blocks,
}: Props) => {
  const { formatNumbers } = useFormatNumbers();

  const style = {
    color: "var(--gray)",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
  };
  if (!blocks) {
    return null;
  }
  return (
    <>
      <div className="d-flex justify-content-between fs-md mt-1 mt-md-0">
        <>
          {blocks?.length <= 1 ? (
            <>
              <span style={style}>
                {blocks[0]?.label} &nbsp;
                <span className="fw-bold">{formatNumbers(received)}</span>
              </span>
            </>
          ) : (
            <>
              <span style={style}>
                {blocks[0].label} &nbsp;
                <span className="fw-bold">{formatNumbers(received)}</span>
              </span>
              <span style={style}>
                {blocks[1].label} &nbsp;
                <span className="fw-bold">{formatNumbers(left < 0 ? 0 : left)}</span>
              </span>
            </>
          )}
        </>
      </div>
      <ProgressBar bgcolor={"var(--primary2)"} progress={progressPrecentage} />
    </>
  );
};

export default HomeDonateProgressBar;
const ProgressBar = ({ bgcolor, progress }) => {
  const completedNum = parseInt(progress) < 3 ? 3 : parseInt(progress);
  const [first, setfirst] = useState(0);
  useIsomorphicLayoutEffect(() => {
    setfirst(1);
  }, [completedNum]);
  const containerStyles = {
    height: 8,
    width: "100%",
    backgroundColor: "var( --light-gray)",
    borderRadius: 50,
  };

  const fillerStyles = {
    height: "100%",
    width: `${first === 0 ? 3 : completedNum}%`,
    backgroundColor: bgcolor,
    borderRadius: "inherit",
    textAlign: "right",
    transition: "width 1s ease-in-out",
  } as const;

  return (
    <div className="mt-2 mb-1" style={containerStyles}>
      <div style={fillerStyles}></div>
    </div>
  );
};
